/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';

interface WidgetProperties {
    style: string;
}

// This component is required to able to apply styles to the options
const DropDownOptionWrapper: React.FC<React.PropsWithChildren<WidgetProperties>> = ({
    style,
    children,
}) => {
    return (
        <div
            css={css`
                ${style || ''}
            `}
        >
            {children}
        </div>
    );
};

export default DropDownOptionWrapper;
